export const queryParams = (params) => {
  let query = "";
  if(params){
    query = "?" + (new URLSearchParams(params).toString());
  }  
  return query;
}

export const clearObject = (obj, keys) => {
  let newObj = {...obj};
  Object.keys(newObj).forEach((key) => keys.includes(key) || delete newObj[key]);
  return newObj;
}

export const formatDate = (date = null) => {
  if(!date){
    date = new Date();
  }else{
    date = new Date(date);
  }
  date = date.toISOString();
  date = date.split(".")[0];
  return date;
}

const originalColorName = (color = null) => {
  switch(color){
    case "3":
    case 3:
      return "red";
    case "2":
    case 2:
      return "yellow";
    case "1":
    case 1:
      return "green";
    case "0":
    case 0:
      return "white";
    default:
      return "gray";
  }
}

const colorNameVFN = (color) => {
  switch(color){
    case 13:
      return "red";
    case 12:
      return "yellow";
    case 11:
      return "darkgreen";
    case 10:
      return "green";
    default:
      return "gray";
  }
}

export const colorName = (color = null) => {
  const colorNum = typeof(color) === "string" ? parseInt(color) : color
  return colorNum >= 10
    ? colorNameVFN(colorNum)
    : originalColorName(colorNum)
}


export const getFormattedDate = (date = Date.now(), wYear = true) => {
  date = new Date(date);
  var dd = ("0" + String(date.getDate())).slice(-2);
  var mm = ("0" + String(date.getMonth() + 1)).slice(-2);
  var yyyy = date.getFullYear();
  return dd+"/"+mm+(wYear ? ("/"+yyyy) : "");
}
export const addMonths = (date = Date.now(), num) => {
  date = new Date(date);
  date.setMonth(date.getMonth()+Math.floor(num));
  let diff = num - Math.floor(num);
  if(diff > 0){
    diff = 30 * diff;
    date.setDate(date.getDate()+diff);
  }
  return date;
}

export const testValidField = (value, required=false) => {
  let valid = true;
  if(required){
    if(typeof value === "undefined"){
      valid = false;
    }else if(value === null){
      valid = false;
    }else if(value.length === 0){
      valid = false;
    }
  }
  return valid;
}


export const tile2lon = (x,z) => { 
  return (x/Math.pow(2,z)*360-180); 
}

export const tile2lat = (y,z) => {
  var n=Math.PI-2*Math.PI*y/Math.pow(2,z);
  return (180/Math.PI*Math.atan(0.5*(Math.exp(n)-Math.exp(-n))));
}


export const ToLL = (north, east, utmZone) => {
  // This is the lambda knot value in the reference
  let LngOrigin = Deg2Rad(utmZone * 6 - 183);

  // The following set of class constants define characteristics of the
  // ellipsoid, as defined my the WGS84 datum.  These values need to be
  // changed if a different dataum is used.

  let FalseNorth = 0;   // South or North?
  //if (lat < 0.) FalseNorth = 10000000.  // South or North?
  //else          FalseNorth = 0.

  let Ecc = 0.081819190842622;       // Eccentricity
  let EccSq = Ecc * Ecc;
  let Ecc2Sq = EccSq / (1. - EccSq);
  // let Ecc2 = Math.sqrt(Ecc2Sq);      // Secondary eccentricity
  let E1 = ( 1 - Math.sqrt(1-EccSq) ) / ( 1 + Math.sqrt(1-EccSq) );
  let E12 = E1 * E1;
  let E13 = E12 * E1;
  let E14 = E13 * E1;

  let SemiMajor = 6378137.0;         // Ellipsoidal semi-major axis (Meters)
  let FalseEast = 500000.0;          // UTM East bias (Meters)
  let ScaleFactor = 0.9996;          // Scale at natural origin

  // Calculate the Cassini projection parameters

  let M1 = (north - FalseNorth) / ScaleFactor;
  let Mu1 = M1 / ( SemiMajor * (1 - EccSq/4.0 - 3.0*EccSq*EccSq/64.0 - 5.0*EccSq*EccSq*EccSq/256.0) );

  let Phi1 = Mu1 + (3.0*E1/2.0 - 27.0*E13/32.0) * Math.sin(2.0*Mu1)
    + (21.0*E12/16.0 - 55.0*E14/32.0)           * Math.sin(4.0*Mu1)
    + (151.0*E13/96.0)                          * Math.sin(6.0*Mu1)
    + (1097.0*E14/512.0)                        * Math.sin(8.0*Mu1);

  let sin2phi1 = Math.sin(Phi1) * Math.sin(Phi1);
  let Rho1 = (SemiMajor * (1.0-EccSq) ) / Math.pow(1.0-EccSq*sin2phi1,1.5);
  let Nu1 = SemiMajor / Math.sqrt(1.0-EccSq*sin2phi1);

  // Compute parameters as defined in the POSC specification.  T, C and D

  let T1 = Math.tan(Phi1) * Math.tan(Phi1);
  let T12 = T1 * T1;
  let C1 = Ecc2Sq * Math.cos(Phi1) * Math.cos(Phi1);
  let C12 = C1 * C1;
  let D  = (east - FalseEast) / (ScaleFactor * Nu1);
  let D2 = D * D;
  let D3 = D2 * D;
  let D4 = D3 * D;
  let D5 = D4 * D;
  let D6 = D5 * D;

  // Compute the Latitude and Longitude and convert to degrees
  let lat = Phi1 - Nu1*Math.tan(Phi1)/Rho1 * ( D2/2.0 - (5.0 + 3.0*T1 + 10.0*C1 - 4.0*C12 - 9.0*Ecc2Sq)*D4/24.0 + (61.0 + 90.0*T1 + 298.0*C1 + 45.0*T12 - 252.0*Ecc2Sq - 3.0*C12)*D6/720.0 );

  lat = Rad2Deg(lat);

  let lng = LngOrigin + (D - (1.0 + 2.0*T1 + C1)*D3/6.0 + (5.0 - 2.0*C1 + 28.0*T1 - 3.0*C12 + 8.0*Ecc2Sq + 24.0*T12)*D5/120.0) / Math.cos(Phi1);

  lng = Rad2Deg(lng);

  return {"lat": lat, "lng": lng};
}

export const latlng = ({lat, lng}) => [lat, lng]

export const Deg2Rad = (degrees) => {
  var pi = Math.PI;
  return degrees * (pi/180);
}

export const Rad2Deg = (radians) => {
  var pi = Math.PI;
  return radians * (180/pi);
}